<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const VipIcon = getIcon("VipIcon");
</script>

{#if typeof VipIcon === 'string'}
	<img src={VipIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof VipIcon === 'function'}
	<svelte:component this={VipIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
